import { useTranslation } from 'react-i18next';

import { isVideo } from '@/util/util';

const Card = ({ media }) => {
  const { t } = useTranslation();

  if (!media) {
    return null;
  }

  if (isVideo(media.url)) {
    return <video src={media.url} muted className="size-full object-cover" />;
  }

  return (
    <img
      src={media.url}
      alt={t('dialog.carousel_first')}
      referrerPolicy="no-referrer"
      className="size-full object-cover"
    />
  );
};

export default Card;
